module.exports = __webpack_public_path__ + "img/horizontal_6_5_7042.2cd9c852.png";